function setLanguageCookie(locale: string) {
  document.cookie = `lang=${locale}; expires=Sun, 1 Jan 2040 00:00:00 GMT; path=/; SameSite=Lax`
}

export default setLanguageCookie
